import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Logo from 'components/atoms/Logo'
import FormResult from 'components/organisms/FormResult'
import FormHeading from 'components/molecules/FormHeading'
import ProgressLoader from 'components/atoms/ProgressLoader'

import CreateAccountForm from 'components/organisms/CreateAccountForm'

const styles = theme => ({
  root: {
    maxWidth: 350,
    display: 'flex',
    margin: '0 auto',
    minHeight: '100vh',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      maxWidth: 450,
    },
  },
  content: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(2)}px`,
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
})

const TrapInviteVerify = ({
  state,
  classes,
  hasError,
  errorMessage,
  onSignupSubmit,
  hasSignupError,
}) => {
  function getContent() {
    if (state === 'signup') {
      return (
        <CreateAccountForm
          onCreateSubmit={onSignupSubmit}
          apiCallError={hasSignupError}
        />
      )
    }

    return !hasError ? (
      <div className={classes.content}>
        <FormHeading heading="Verifying your invitation..." />
        <ProgressLoader color="primary" />
      </div>
    ) : (
      <div className={classes.content}>
        <FormResult
          hideButton
          heading="Something went wrong"
          subHeading={errorMessage}
        />
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <Logo className={classes.logo} />
      {getContent()}
    </div>
  )
}

TrapInviteVerify.propTypes = {
  state: PropTypes.string,
  hasError: PropTypes.bool,
  classes: PropTypes.object,
  errorMessage: PropTypes.string,
  onSignupSubmit: PropTypes.func,
  hasSignupError: PropTypes.bool,
}

export default withStyles(styles)(TrapInviteVerify)



// WEBPACK FOOTER //
// ./src/containers/invitations/TrapInviteVerify/TrapInviteVerify.js